<template>
  <BasicFilterItem class="filter-item__code"
                   :title="title"
                   :options="options"
                   @hide="handleHide"
  >
    <div class="filter-item__code-input p-1">
      <b-input-group :class="{ 'disabled': disabled }">
        <b-input-group-prepend is-text><b-icon icon="search" class="font-weight-bold text-black" /></b-input-group-prepend>

        <b-form-input id="popover-code-autocomplete"
                      v-model="keyword"
                      name="prefix"
                      data-test-id="filter-item__code-input"
                      debounce="300"
                      :disabled="disabled"
                      :placeholder="placeholder"
                      @change="handleChange"
                      @keyup="fetchCodes"
                      @keydown.enter="handleHide"
        />
      </b-input-group>
      <b-popover target="popover-code-autocomplete"
                 triggers="manual"
                 custom-class="popover-code"
                 placement="bottom"
                 data-test-id="filter-item__options"
                 @hide.prevent=""
      >
        <span />
        <button v-for="code in codes" :key="'filter-code-' + code.code" class="dropdown-item" @click="handleChange(code.code)">{{ code.code }}</button>
      </b-popover>
    </div>
  </BasicFilterItem>
</template>

<script>
import BasicFilterItem from '@/components/common/BasicFilterItem'
import {bdService} from '@/services'

export default {
  components: {
    BasicFilterItem
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: false,
      default() { return [] }
    }
  },
  data() {
    return {
      keyword: '',
      codes: []
    }
  },
  watch: {
    codes(n) {
      this.$root.$emit(n.length > 0 ? 'bv::show::popover' : 'bv::hide::popover', 'popover-code-autocomplete')
    }
  },
  methods: {
    handleChange(code) {
      if (code.length) {
        this.keyword = code.toUpperCase()
        this.handleHide()
      }
    },
    handleHide() {
      if (this.keyword.length && !this.options.some(k => k.label.toUpperCase() === this.keyword.toUpperCase()) && this.codes.find(k => k.code.toUpperCase() === this.keyword.toUpperCase())) {
        this.options.push({label: this.keyword.toUpperCase(), value: true})
        this.keyword = ''
        this.codes = []
        this.$emit('updated')
      }
    },
    fetchCodes(e) {
      if (e.target.value.length >= 3 && !this.disabled) {
        bdService.fetchFaultCodesAutocomplete(e.target.value).then(r => this.codes = r.data)
      } else {
        this.codes = []
      }
    }
  }
}
</script>

<style lang="scss">
.popover-code {
  .popover-body {
    padding: 0;
    max-height: 200px;
    overflow-y: scroll;
  }

  .dropdown-item {
    cursor: pointer;
  }
}

.filter-item__code {
  button {
    width: 10rem;
  }

  input,
  .input-group-text {
    padding: .5rem .3rem;
  }
}
</style>
